export const maskEmail = (email?: string | null): string | undefined => {
  if (!email) return undefined;

  const [local, domain] = email.split('@');
  if (!local || !domain) {
    return undefined;
  }

  if (local.length <= 3) {
    return `${'*'.repeat(local.length)}@${domain}`;
  }

  // Preserve first 2 and last character; replace the rest with *
  const masked = local.slice(0, 2) + '*'.repeat(local.length - 3) + local.slice(-1);

  return `${masked}@${domain}`;
};
